/* Auto-generated resource aggregator for i18next. Do not edit manually. */
import commonar from './locales/ar/common.json';
import navar from './locales/ar/nav.json';
import homear from './locales/ar/home.json';
import storear from './locales/ar/store.json';
import marketplacear from './locales/ar/marketplace.json';
import auctionar from './locales/ar/auction.json';
import offersar from './locales/ar/offers.json';
import usernamear from './locales/ar/username.json';
import walletar from './locales/ar/wallet.json';
import nftar from './locales/ar/nft.json';
import ownershipar from './locales/ar/ownership.json';
import profilear from './locales/ar/profile.json';
import settingsar from './locales/ar/settings.json';
import notificationsar from './locales/ar/notifications.json';
import validationar from './locales/ar/validation.json';
import errorsar from './locales/ar/errors.json';
import adminar from './locales/ar/admin.json';
import rulesar from './locales/ar/rules.json';
import p2par from './locales/ar/p2p.json';
import sharedar from './locales/ar/shared.json';
import stakingar from './locales/ar/staking.json';
import commonen from './locales/en/common.json';
import naven from './locales/en/nav.json';
import homeen from './locales/en/home.json';
import storeen from './locales/en/store.json';
import marketplaceen from './locales/en/marketplace.json';
import auctionen from './locales/en/auction.json';
import offersen from './locales/en/offers.json';
import usernameen from './locales/en/username.json';
import walleten from './locales/en/wallet.json';
import nften from './locales/en/nft.json';
import ownershipen from './locales/en/ownership.json';
import profileen from './locales/en/profile.json';
import settingsen from './locales/en/settings.json';
import notificationsen from './locales/en/notifications.json';
import validationen from './locales/en/validation.json';
import errorsen from './locales/en/errors.json';
import adminen from './locales/en/admin.json';
import rulesen from './locales/en/rules.json';
import p2pen from './locales/en/p2p.json';
import shareden from './locales/en/shared.json';
import stakingen from './locales/en/staking.json';
import commontr from './locales/tr/common.json';
import navtr from './locales/tr/nav.json';
import hometr from './locales/tr/home.json';
import storetr from './locales/tr/store.json';
import marketplacetr from './locales/tr/marketplace.json';
import auctiontr from './locales/tr/auction.json';
import offerstr from './locales/tr/offers.json';
import usernametr from './locales/tr/username.json';
import wallettr from './locales/tr/wallet.json';
import nfttr from './locales/tr/nft.json';
import ownershiptr from './locales/tr/ownership.json';
import profiletr from './locales/tr/profile.json';
import settingstr from './locales/tr/settings.json';
import notificationstr from './locales/tr/notifications.json';
import validationtr from './locales/tr/validation.json';
import errorstr from './locales/tr/errors.json';
import admintr from './locales/tr/admin.json';
import rulestr from './locales/tr/rules.json';
import p2ptr from './locales/tr/p2p.json';
import sharedtr from './locales/tr/shared.json';
import stakingtr from './locales/tr/staking.json';
import commonru from './locales/ru/common.json';
import navru from './locales/ru/nav.json';
import homeru from './locales/ru/home.json';
import storeru from './locales/ru/store.json';
import marketplaceru from './locales/ru/marketplace.json';
import auctionru from './locales/ru/auction.json';
import offersru from './locales/ru/offers.json';
import usernameru from './locales/ru/username.json';
import walletru from './locales/ru/wallet.json';
import nftru from './locales/ru/nft.json';
import ownershipru from './locales/ru/ownership.json';
import profileru from './locales/ru/profile.json';
import settingsru from './locales/ru/settings.json';
import notificationsru from './locales/ru/notifications.json';
import validationru from './locales/ru/validation.json';
import errorsru from './locales/ru/errors.json';
import adminru from './locales/ru/admin.json';
import rulesru from './locales/ru/rules.json';
import p2pru from './locales/ru/p2p.json';
import sharedru from './locales/ru/shared.json';
import stakingru from './locales/ru/staking.json';
import commonko from './locales/ko/common.json';
import navko from './locales/ko/nav.json';
import homeko from './locales/ko/home.json';
import storeko from './locales/ko/store.json';
import marketplaceko from './locales/ko/marketplace.json';
import auctionko from './locales/ko/auction.json';
import offersko from './locales/ko/offers.json';
import usernameko from './locales/ko/username.json';
import walletko from './locales/ko/wallet.json';
import nftko from './locales/ko/nft.json';
import ownershipko from './locales/ko/ownership.json';
import profileko from './locales/ko/profile.json';
import settingsko from './locales/ko/settings.json';
import notificationsko from './locales/ko/notifications.json';
import validationko from './locales/ko/validation.json';
import errorsko from './locales/ko/errors.json';
import adminko from './locales/ko/admin.json';
import rulesko from './locales/ko/rules.json';
import p2pko from './locales/ko/p2p.json';
import sharedko from './locales/ko/shared.json';
import stakingko from './locales/ko/staking.json';
import commonzhCN from './locales/zh-CN/common.json';
import navzhCN from './locales/zh-CN/nav.json';
import homezhCN from './locales/zh-CN/home.json';
import storezhCN from './locales/zh-CN/store.json';
import marketplacezhCN from './locales/zh-CN/marketplace.json';
import auctionzhCN from './locales/zh-CN/auction.json';
import offerszhCN from './locales/zh-CN/offers.json';
import usernamezhCN from './locales/zh-CN/username.json';
import walletzhCN from './locales/zh-CN/wallet.json';
import nftzhCN from './locales/zh-CN/nft.json';
import ownershipzhCN from './locales/zh-CN/ownership.json';
import profilezhCN from './locales/zh-CN/profile.json';
import settingszhCN from './locales/zh-CN/settings.json';
import notificationszhCN from './locales/zh-CN/notifications.json';
import validationzhCN from './locales/zh-CN/validation.json';
import errorszhCN from './locales/zh-CN/errors.json';
import adminzhCN from './locales/zh-CN/admin.json';
import ruleszhCN from './locales/zh-CN/rules.json';
import p2pzhCN from './locales/zh-CN/p2p.json';
import sharedzhCN from './locales/zh-CN/shared.json';
import stakingzhCN from './locales/zh-CN/staking.json';
import commonuk from './locales/uk/common.json';
import navuk from './locales/uk/nav.json';
import homeuk from './locales/uk/home.json';
import storeuk from './locales/uk/store.json';
import marketplaceuk from './locales/uk/marketplace.json';
import auctionuk from './locales/uk/auction.json';
import offersuk from './locales/uk/offers.json';
import usernameuk from './locales/uk/username.json';
import walletuk from './locales/uk/wallet.json';
import nftuk from './locales/uk/nft.json';
import ownershipuk from './locales/uk/ownership.json';
import profileuk from './locales/uk/profile.json';
import settingsuk from './locales/uk/settings.json';
import notificationsuk from './locales/uk/notifications.json';
import validationuk from './locales/uk/validation.json';
import errorsuk from './locales/uk/errors.json';
import adminuk from './locales/uk/admin.json';
import rulesuk from './locales/uk/rules.json';
import p2puk from './locales/uk/p2p.json';
import shareduk from './locales/uk/shared.json';
import stakinguk from './locales/uk/staking.json';
import commonfa from './locales/fa/common.json';
import navfa from './locales/fa/nav.json';
import homefa from './locales/fa/home.json';
import storefa from './locales/fa/store.json';
import marketplacefa from './locales/fa/marketplace.json';
import auctionfa from './locales/fa/auction.json';
import offersfa from './locales/fa/offers.json';
import usernamefa from './locales/fa/username.json';
import walletfa from './locales/fa/wallet.json';
import nftfa from './locales/fa/nft.json';
import ownershipfa from './locales/fa/ownership.json';
import profilefa from './locales/fa/profile.json';
import settingsfa from './locales/fa/settings.json';
import notificationsfa from './locales/fa/notifications.json';
import validationfa from './locales/fa/validation.json';
import errorsfa from './locales/fa/errors.json';
import adminfa from './locales/fa/admin.json';
import rulesfa from './locales/fa/rules.json';
import p2pfa from './locales/fa/p2p.json';
import sharedfa from './locales/fa/shared.json';
import stakingfa from './locales/fa/staking.json';

export const resources = {
  'ar': {
    common: commonar,
    nav: navar,
    home: homear,
    store: storear,
    marketplace: marketplacear,
    auction: auctionar,
    offers: offersar,
    username: usernamear,
    wallet: walletar,
    nft: nftar,
    ownership: ownershipar,
    profile: profilear,
    settings: settingsar,
    notifications: notificationsar,
    validation: validationar,
    errors: errorsar,
    admin: adminar,
    rules: rulesar,
    p2p: p2par,
    shared: sharedar,
    staking: stakingar,
  },
  'en': {
    common: commonen,
    nav: naven,
    home: homeen,
    store: storeen,
    marketplace: marketplaceen,
    auction: auctionen,
    offers: offersen,
    username: usernameen,
    wallet: walleten,
    nft: nften,
    ownership: ownershipen,
    profile: profileen,
    settings: settingsen,
    notifications: notificationsen,
    validation: validationen,
    errors: errorsen,
    admin: adminen,
    rules: rulesen,
    p2p: p2pen,
    shared: shareden,
    staking: stakingen,
  },
  'tr': {
    common: commontr,
    nav: navtr,
    home: hometr,
    store: storetr,
    marketplace: marketplacetr,
    auction: auctiontr,
    offers: offerstr,
    username: usernametr,
    wallet: wallettr,
    nft: nfttr,
    ownership: ownershiptr,
    profile: profiletr,
    settings: settingstr,
    notifications: notificationstr,
    validation: validationtr,
    errors: errorstr,
    admin: admintr,
    rules: rulestr,
    p2p: p2ptr,
    shared: sharedtr,
    staking: stakingtr,
  },
  'ru': {
    common: commonru,
    nav: navru,
    home: homeru,
    store: storeru,
    marketplace: marketplaceru,
    auction: auctionru,
    offers: offersru,
    username: usernameru,
    wallet: walletru,
    nft: nftru,
    ownership: ownershipru,
    profile: profileru,
    settings: settingsru,
    notifications: notificationsru,
    validation: validationru,
    errors: errorsru,
    admin: adminru,
    rules: rulesru,
    p2p: p2pru,
    shared: sharedru,
    staking: stakingru,
  },
  'ko': {
    common: commonko,
    nav: navko,
    home: homeko,
    store: storeko,
    marketplace: marketplaceko,
    auction: auctionko,
    offers: offersko,
    username: usernameko,
    wallet: walletko,
    nft: nftko,
    ownership: ownershipko,
    profile: profileko,
    settings: settingsko,
    notifications: notificationsko,
    validation: validationko,
    errors: errorsko,
    admin: adminko,
    rules: rulesko,
    p2p: p2pko,
    shared: sharedko,
    staking: stakingko,
  },
  'zh-CN': {
    common: commonzhCN,
    nav: navzhCN,
    home: homezhCN,
    store: storezhCN,
    marketplace: marketplacezhCN,
    auction: auctionzhCN,
    offers: offerszhCN,
    username: usernamezhCN,
    wallet: walletzhCN,
    nft: nftzhCN,
    ownership: ownershipzhCN,
    profile: profilezhCN,
    settings: settingszhCN,
    notifications: notificationszhCN,
    validation: validationzhCN,
    errors: errorszhCN,
    admin: adminzhCN,
    rules: ruleszhCN,
    p2p: p2pzhCN,
    shared: sharedzhCN,
    staking: stakingzhCN,
  },
  'uk': {
    common: commonuk,
    nav: navuk,
    home: homeuk,
    store: storeuk,
    marketplace: marketplaceuk,
    auction: auctionuk,
    offers: offersuk,
    username: usernameuk,
    wallet: walletuk,
    nft: nftuk,
    ownership: ownershipuk,
    profile: profileuk,
    settings: settingsuk,
    notifications: notificationsuk,
    validation: validationuk,
    errors: errorsuk,
    admin: adminuk,
    rules: rulesuk,
    p2p: p2puk,
    shared: shareduk,
    staking: stakinguk,
  },
  'fa': {
    common: commonfa,
    nav: navfa,
    home: homefa,
    store: storefa,
    marketplace: marketplacefa,
    auction: auctionfa,
    offers: offersfa,
    username: usernamefa,
    wallet: walletfa,
    nft: nftfa,
    ownership: ownershipfa,
    profile: profilefa,
    settings: settingsfa,
    notifications: notificationsfa,
    validation: validationfa,
    errors: errorsfa,
    admin: adminfa,
    rules: rulesfa,
    p2p: p2pfa,
    shared: sharedfa,
    staking: stakingfa,
  },
} as const;

export const supportedLanguages = ["ar","en","tr","ru","ko","zh-CN","uk","fa"] as const;
